/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />
/// <reference path="../filters/currencyFilter.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoPercentageField implements angular.IDirective {
        restrict = "E";
        require = 'ngModel';
        scope = {
            currentValue: "=ngModel",
            contentKey: "@",
            disabled: "=ngDisabled",
            required: "=ngRequired",
            backgroundColor: "=",
            onPostBlur: "&?",
            maxlength: "=?",
            maxValue: "=?",
            decimalMask: '=?',
            showDecimalMask: '=?',   // format display value after `blur`
            ngChange: "&",
            percentageValue: '=?',   // add ui-percentage-value attribute if needed
            forcedDisplayValue: '=?',
            supportsNull: "=",
            nullPlaceholder: "@?",
            zeroInvalid: "=?",
            maxValueValidation: "=?",
            name: "@",
            tabIndex: '=?',
            allowNegatives: '=?',
            showDecimalMaskForZero: "=?",
            defaultValue: "@?",
        };

        templateUrl = "app/components/controls/percentageFieldTemplate.html";

        compile = (element: ng.IAugmentedJQuery, attrs: ng.IAttributes) => {

            //if (attrs.hasOwnProperty('percentageValue') && Boolean(attrs['percentageValue']) === true) {
            //    element.find('input')[0].setAttribute('ui-percentage-value', '');
            //}


            return (scope: any, element: JQuery, attrs: angular.IAttributes, ngModel: angular.INgModelController) => {

                var backspacePressed = false;
                var input = element.find('input');
                let locale = this.$locale;
                let postBlurDelayed = false;
                let hasFocus = false;

                const shouldShowDecimalMask = () => {
                    return scope.showDecimalMask === true &&
                        scope.decimalMask !== undefined &&
                        scope.decimalMask !== null &&
                        scope.decimalMask >= 0;
                };

                if (scope.nullPlaceholder)
                    input.attr("placeholder", this.$translate.instant(scope.nullPlaceholder));

                scope.previouslyStoredNewValue = null;
                scope.previouslyStoredOldValue = null;

                if (Model.Guard.isSomething(scope.currentValue, false)) {
                    const currentValue = scope.currentValue * 100;
                    if (shouldShowDecimalMask()) {
                        scope.displayValue = formatDecimalMask(currentValue.toString(), scope.decimalMask);
                    } else {
                        scope.displayValue = currentValue.toFixed(scope.decimalMask) + "%";
                    }
                } else {
                    if (scope.supportsNull) {
                        scope.currentValue = null;
                    }
                    else {
                        scope.currentValue = 0;
                        if (shouldShowDecimalMask()) {
                            scope.displayValue = formatDecimalMask("0", scope.decimalMask);
                        } else {
                            scope.displayValue = scope.showDecimalMaskForZero ? parseInt('0').toFixed(scope.decimalMask)+"%" : "0%";
                        }
                    }
                }
                scope.previouslyStoredNewValue = scope.displayValue;

                if (angular.isUndefined(scope.maxValue)) {
                    scope.maxValue = '9999999' + locale.NUMBER_FORMATS.DECIMAL_SEP + '99';
                }
                scope.showMaxValueError = false;

                if (angular.isUndefined(scope.maxlength)) {
                    scope.maxlength = 14;
                }

                if (angular.isUndefined(scope.decimalMask)) {
                    scope.decimalMask = 4;
                }

                scope.onFocus = () => {
                    hasFocus = true;
                };

                scope.onBlur = () => {
                    hasFocus = false;
                    if (shouldShowDecimalMask()) {
                        const formatted = formatDecimalMask(scope.displayValue, scope.decimalMask);
                        if (scope.displayValue !== formatted) {
                            postBlurDelayed = true;
                            scope.displayValue = formatted;
                        }
                    }
                    if (!postBlurDelayed && _.isFunction(scope.onPostBlur)) {
                        scope.onPostBlur();
                    }
                }

                element.on("keydown", (event: JQueryEventObject) => {
                    if (event.keyCode === 8)
                        backspacePressed = true;
                    else
                        backspacePressed = false;

                    if (_.contains([46, 8, 9, 27, 13], event.keyCode) ||
                        // decimal keys (beside the comma key, and the numeric-pad key).  Check shift key to prevent >.  Don't allow multiple periods.
                        (scope.decimalMask >= 1 && _.contains([110, 190], event.keyCode) && !event.shiftKey && Model.Guard.isSomething(scope.displayValue) && scope.displayValue.indexOf(locale.NUMBER_FORMATS.DECIMAL_SEP) === -1) ||
                        // Allow: Ctrl+A
                        (event.keyCode === 65 && event.ctrlKey) ||
                        // Allow: Ctrl+C
                        (event.keyCode === 67 && event.ctrlKey) ||
                        // Allow: Ctrl+X
                        (event.keyCode === 88 && event.ctrlKey) ||
                        // Allow: home, end, left, right
                        (event.keyCode >= 35 && event.keyCode <= 39)) {

                        if (event.keyCode === 13 && _.isFunction(scope.onEnter)) {
                            scope.onEnter({ event: event });
                        }



                        // let it happen, don't do anything
                        return;
                    }

                    if(scope.allowNegatives && [109, 189].indexOf(event.keyCode) !== -1) return;

                    // Ensure that it is a number and stop the keypress
                    if ((event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) && (event.keyCode < 96 || event.keyCode > 105)) {
                        event.preventDefault();
                    }

                    return true;
                });

                scope.$watch(() => scope.forcedDisplayValue, (newVal: string, oldVal: string) => {
                    if (!angular.isUndefined(scope.forcedDisplayValue) && scope.forcedDisplayValue.indexOf("%") == -1 && scope.forcedDisplayValue.indexOf(locale.NUMBER_FORMATS.DECIMAL_SEP) == -1 && scope.decimalMask != null && scope.decimalMask > 0) {
                        var zeros = "";
                        for (var index = 0; index < scope.decimalMask; index++) {
                            zeros += "0";
                        }
                        scope.displayValue = scope.forcedDisplayValue.substring(0, scope.forcedDisplayValue.length) + locale.NUMBER_FORMATS.DECIMAL_SEP + zeros + "%";
                    }
                    else if (!angular.isUndefined(scope.forcedDisplayValue) && scope.forcedDisplayValue.indexOf("%") == -1 && scope.forcedDisplayValue.indexOf(locale.NUMBER_FORMATS.DECIMAL_SEP) != -1 && scope.decimalMask != null && scope.decimalMask > 0) {
                        var zeros = "";
                        for (var index = 0; index < scope.decimalMask; index++) {
                            zeros += "0";
                        }
                        scope.displayValue = scope.forcedDisplayValue.substring(0, scope.forcedDisplayValue.indexOf(locale.NUMBER_FORMATS.DECIMAL_SEP)) + locale.NUMBER_FORMATS.DECIMAL_SEP + zeros + "%";
                    }
                    else if (!angular.isUndefined(scope.forcedDisplayValue))
                        scope.displayValue = scope.forcedDisplayValue;
                });


                //// this watch will trigger the watch below which will then process the data properly in case of a direct value change instead of a typed change
                scope.$watch(() => scope.currentValue, (newVal: string, oldVal: string) => {

                    // We check what value we get. It returns the previous value if we insert a non-numeric value into the field
                    if (isNaN(Number(newVal))) {
                        scope.currentValue = oldVal;
                    }

                    if (Model.Guard.isSomething(scope.currentValue, false)) {

                        let decimalLengthValue = 0;
                        const currentValue = scope.currentValue.toString();
                        const currentValueDecimalIndex = currentValue.indexOf(locale.NUMBER_FORMATS.DECIMAL_SEP);

                        if (currentValueDecimalIndex != -1) {
                            // subtract 2 decimal places because currentValue is a percent value which is divided by 100 meaning that there will always be 2 at least decimal places present which should not be counted against the decimal mask
                            decimalLengthValue = currentValue.substring(currentValueDecimalIndex + 1, currentValue.length).length - 2;
                            // decimalLengthValue is -1 for 0.1, 0.2, etc... clamp to 0
                            decimalLengthValue = Math.max(0, decimalLengthValue);
                        }

                        if ((decimalLengthValue >= scope.decimalMask && currentValueDecimalIndex != -1) || (currentValue === '0' && scope.showDecimalMaskForZero)) {
                            // if decimals are present then follow decimal mask rule
                            decimalLengthValue = scope.decimalMask;
                        }

                        const value = scope.currentValue * 100;
                        const formatted = (hasFocus === false && shouldShowDecimalMask())
                            ? formatDecimalMask(value.toString(), scope.decimalMask)
                            : value.toFixed(decimalLengthValue) + "%";
                        scope.displayValue = formatted;
                    }
                    else if (scope.supportsNull && scope.currentValue === null) {
                        scope.displayValue = null;
                    }

                    validate();
                });

                scope.$watch(() => scope.displayValue, (newVal: string, oldVal: string) => {
                    // each of the if statements below check very specific conditions which are outlined with comments above so that any programmer can read and understand what each statement is handling since this is a watch and every time scope.displayValue is changed another watch iteration is called. it is very important to understand that otherwise changes to this code will result in much frustration and debugging.

                    const newValue = newVal;

                    // only perform changes if a value has changed
                    // this is to prevent the iteration from being called when the value is loaded for the first time
                    if (Model.Guard.isSomething(newVal, false) && newVal != oldVal) {

                        // If the defaultValue is specified, but the user is trying to set an empty value,
                        // for example by clearing out the textbox or leaving no digits in there,
                        // we reset the value to the specified defaultValue.
                        if (
                            (newVal === undefined || newVal === null || newVal === "" || newVal === "%") &&
                            (scope.defaultValue !== undefined && scope.defaultValue !== null && scope.defaultValue !== "")
                        ) {
                            scope.displayValue = scope.defaultValue;
                            return;
                        }

                        // this if statement below handles the specific scenario where a user decided to delete the last digit of numerical %
                        // value and this triggered an attempt to retrieve the value from the grave because of the change in the displayed value
                        // to a single digit numerical value and the recursive nature of this watch evaluation
                        // Explained Scenario: the cursor is to the right of the % sign and user pressed delete character
                        // while there is only 1 character left besides the % sign
                        // currentValue: "5%" -> after backspace is pressed ->  new Value: ""
                        if (newVal.length == 0 && Model.Guard.isSomething(oldVal, false) && oldVal.length == 1 && oldVal.indexOf("%") == -1 && newVal.indexOf("%") == -1 && (scope.previouslyStoredNewValue != oldVal || (scope.previouslyStoredNewValue + "%") != scope.previouslyStoredOldValue)) {
                            scope.displayValue = oldVal;
                            return;
                        }


                        // this if statement allows the user to press delete after the % sign and it deletes the current right-most number value
                        if (newVal.length >= 1 && newVal.indexOf("%") == -1 && Model.Guard.isSomething(oldVal, false) && oldVal.indexOf("%") != -1 && backspacePressed) {
                            // store both of the values when this was triggered because this may have been the last number remaining
                            // besides the % sign which means we do not need to retrieve the value from the grave!
                            scope.previouslyStoredOldValue = oldVal;
                            scope.previouslyStoredNewValue = scope.displayValue;

                            newVal = newVal.substring(0, newVal.length - 1);
                            scope.displayValue = newVal; // since this value has changed this will trigger another watch call which will continue further down the stack and will modify the value below properly

                            return;
                        }

                        // this if is for handling user input when people enter a number after the % sign
                        // in this case just append the number as the last digit in the numerical value
                        if (newVal && newVal.length >= 1 && newVal.length - 1 > newVal.indexOf("%") && newVal.indexOf("%") != -1) {
                            newVal = newVal.substring(0, newVal.length - 2) + newVal.substring(newVal.length - 1, newVal.length);
                            scope.displayValue = newVal;
                        }

                        // check if the input box has a value and re-assign the value to the ng-model parent called "currentValue" as long as the criteria below is met
                        if (newVal != null && newVal.length >= 1) {
                            // the if statement below prevents a reasonable whole number with a period afterwards from causing an error
                            // this only happens if the user has a period with no decimal values afterwards EX: "1.%" or "2.%"
                            if (newVal.indexOf(locale.NUMBER_FORMATS.DECIMAL_SEP) != (newVal.length - 2) && newVal.indexOf("%") != -1) {
                                // the statement below makes sure that the value typed follows the Precision and Max Value Rules
                                newVal = scope.enforceValueConstraints(newVal);
                                
                                scope.currentValue = parseFloat((parseFloat(newVal.substring(0, newVal.length - 1)) / 100).toFixed(scope.decimalMask + 2));
                                
                                // The `onblur` handler may write to `scope.displayValue`, so this function might run after the blur event.
                                // Use the 'newer' formatting only if requested and after the blur event. Otherwise, run pre-existing code.
                                if (hasFocus === false && shouldShowDecimalMask()) {
                                    scope.displayValue = formatDecimalMask(newVal, scope.decimalMask);
                                } else {
                                    scope.displayValue = newVal.toString();
                                }
                            }

                            //append a % sign if and only if there is no % sign already appended
                            if (scope.displayValue.length >= 1 && scope.displayValue.indexOf("%") === -1)
                                scope.displayValue = scope.displayValue + "%";
                        }
                    }
                    
                    // The `onPostBlur` handler might not have been invoked due to `onblur` display value formatting.
                    // If that is the case (`postBlurDelayed` is set to `true`), we need to invoke it here,
                    // but ONLY after this `$watch` handler settles. That is, after all of the above processing is done,
                    // the `newVal` is the same as the `scope.displayValue` and we do not expect another invocation during
                    // the current digest cycle.
                    if (postBlurDelayed && newValue === scope.displayValue && _.isFunction(scope.onPostBlur)) {
                        scope.onPostBlur();
                        postBlurDelayed = false;
                    }
                });

                scope.enforceValueConstraints = (value: string) => {
                    // check max value constraint
                    if (scope.maxValue != null && parseFloat(value.substring(0, value.length - 1)) >= scope.maxValue) {
                        if (scope.maxValueValidation) {
                            scope.showMaxValueError = true;

                            this.$timeout(() => {
                                scope.showMaxValueError = false;
                            }, 1000);
                        }

                        return scope.maxValue + "%";
                    }

                    // check decimal precision constraint
                    if (value.indexOf(locale.NUMBER_FORMATS.DECIMAL_SEP) != -1 && value.indexOf(locale.NUMBER_FORMATS.DECIMAL_SEP) < value.length && scope.getNumberOfZerosAfterDecimalPlace(value) > parseInt(scope.decimalMask) + 1) {
                        return value.substring(0, value.indexOf(locale.NUMBER_FORMATS.DECIMAL_SEP)) + value.substring(value.indexOf(locale.NUMBER_FORMATS.DECIMAL_SEP), value.indexOf(locale.NUMBER_FORMATS.DECIMAL_SEP) + (parseInt(scope.decimalMask) + 1)) + "%";
                    }

                    return value;
                }

                function validate() {
                    if (scope.zeroInvalid) {
                        let isValid = !!parseFloat(scope.displayValue);

                        ngModel.$setValidity("zero", isValid);
                    }
                }

                scope.getNumberOfZerosAfterDecimalPlace = (value: string) => {
                    if (value.indexOf("%") != -1)
                        return value.substring(value.indexOf(locale.NUMBER_FORMATS.DECIMAL_SEP), value.length - 1).length;
                    else
                        return value.substring(value.indexOf(locale.NUMBER_FORMATS.DECIMAL_SEP), value.length).length;
                }

                function formatDecimalMask(value: string, decimals: number): string {
                    let val = value;
                    if (val === undefined || val === null) {
                        val = "0";
                    }
                    // The keydown handler should handle most of this, but to be safe,
                    // remove all non-number related chars. Keep: '-', '.', and digits.
                    val = val.replace(/[^-\d\.]/g, "");
                    if (val === "") {
                        val = "0";
                    }
                    // The minus sign is allowed to be entered in between digits (e.g. 2.-3%).
                    // Multiple minus signs also seem to be allowed (e.g. 2--3%, -2-3%, -1-.23%).
                    // If there are any minus signs, assume user wanted a negative number and try to normalize it.
                    const negative = val.indexOf("-") > -1;
                    if (negative) {
                        val = val.replaceAll("-", "");
                    }
                    let num = parseFloat(val);
                    if (isNaN(num)) {
                        num = 0.0;
                    }
                    if (negative) {
                        num *= -1;
                    }
                    const out = num.toFixed(decimals) + "%";
                    return out;
                }
            }
        };

        constructor(
            private $translate: angular.translate.ITranslateService,
            private $timeout: ng.ITimeoutService,
            private $locale: angular.ILocaleService
        ) {

        }

        static factory(): angular.IDirectiveFactory {
            let directive = (
                $translate: ng.translate.ITranslateService,
                $timeout: ng.ITimeoutService,
                $locale: angular.ILocaleService
            ) => {
                return new MeevoPercentageField($translate, $timeout, $locale);
            };

            directive.$inject = ["$translate", "$timeout", "$locale"];
            return directive;
        }
    }
    angular.module("meevo.components.controls")
        .directive("meevoPercentageField", MeevoPercentageField.factory());
}
